
import { mapState } from 'vuex';
import PageFooter from '@justeat/f-footer';
import PageHeader from '@justeat/f-header';
import CookieBanner from '@justeat/f-cookie-banner';
import metadataMixin from '@/mixins/metadataMixin.vue';

export default {
    components: {
        PageFooter,
        PageHeader,
        CookieBanner
    },

    mixins: [
        metadataMixin
    ],

    computed: {
        ...mapState('cms', [
            'footerContent'
        ]),

        ...mapState('globalisation', [
            'locale'
        ])
    },

    created () {
        this.$root.$i18n.locale = this.locale;
    }
};
